import React from 'react';

import { Card, CardActionArea, CardContent, Chip, Stack, Tooltip, Typography } from '@mui/material';

type Rate = {
  code: string;
};

export type Vendor = {
  id: string;
  name: string;
  rates: Array<Rate>;
};

interface Props {
  vendor: Vendor;
  selected: boolean;
  onSelect: () => void;
}

function VendorTab({ vendor, selected, onSelect }: Props) {
  const visibleRates = vendor.rates.slice(0, 1);
  const remainingRateCount = vendor.rates.length - visibleRates.length;

  return (
    <Card variant="outlined" sx={{ minWidth: 280, borderColor: selected ? 'primary.main' : undefined }}>
      <CardActionArea onClick={onSelect} data-testid={`vendor-card-${vendor.id}`}>
        <CardContent>
          <Typography variant="subtitle1" fontWeight={selected ? 700 : 500}>
            {vendor.name}
          </Typography>
          <Stack direction="row" spacing={0.5} mt={1} alignItems="center" sx={{ minWidth: 0, overflow: 'hidden' }}>
            {visibleRates.map((rate) => (
              <Tooltip key={rate.code} title={rate.code}>
                <Chip
                  label={rate.code}
                  size="small"
                  sx={{
                    maxWidth: remainingRateCount > 0 ? 180 : '100%',
                    '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
                  }}
                />
              </Tooltip>
            ))}
            {remainingRateCount > 0 && <Chip label={`+${remainingRateCount}`} size="small" variant="outlined" />}
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

export default VendorTab;
